/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState, useContext } from 'react';
import { ExperienceContext, useConfigService, } from '@thd-nucleus/experience-context';
import { Pagination } from '@thd-olt-component-react/pagination';
import { Alert, Button, Typography, Checkbox, SelectionControlLabel, } from '@one-thd/sui-atomic-components';
import { ManageUserForm } from '../user-form/manage-user-form/manage-user-form';
import { UserPermissionsToggle } from '../users-toggle-permissions/users-toggle-permissions';
import { BulkAdd } from '../bulk-add-users/bulk-add';
import { checkIsInviteExpirationEnabled, scrollToTop, } from '../../utils/general';
import { getViewPurchasePermission, getViewHistoryPayload, } from '../../utils/user-permissions';
import { UsersSearch } from '../users-search/users-search';
import { MAX_PAGES_TO_SHOW_ARROWS } from '../../constants/pagination';
import { USER_ADDED_SUCCESS_MSG, USER_REMOVED_SUCCESS_MSG, USER_UPDATED_SUCCESS_MSG, USERS_REMOVED_SUCCESS_MSG, MULTI_RESEND_INVITE_SUCCESS_MSG, USER_ADDED_SUCCESS_MSG_WITH_EXPIRATION_DATE, MULTI_RESEND_INVITE_SUCCESS_MSG_WITH_EXPIRATION, } from '../../constants/response-success-messages';
import { ERR_GENERIC, MULTI_RESEND_INVITE_ERROR_MSG, ERR_UNABLE_TO_SAVE_PAYMENT_PERMISSIONS, } from '../../constants/response-error-messages';
import { ManageUsersHeader } from '../manage-users-header/manage-users-header';
import { UserCard } from '../user-card/user-card';
import { generateSortByOptions } from '../../utils/sort';
import Spinner from '../shared/spinner/spinner';
import { useAddManageUsers } from '../../hooks/use-add-manage-users';
import { useModal } from '../../hooks/use-modal';
import { defaultFilterConfig, defaultSortByOptions, USER_FORM_MODE, } from '../../models/b2b/add-manage-users';
import { TAlertStatus, TAlertType } from '../../models/common/alert-messages';
import { getNewPageNumber } from '../../utils/pagination';
import { UserForm } from '../user-form/user-form';
import { UserSortOrder } from '../user-sort-order/user-sort-order';
import { setBulkRemoveUsersSuccessAnalytics, setMultiSelectOperationLinkAnalytics, setMyAccountPageAnalytics, setResendUserInvitesSuccessAnalytics, setSearchSortResultsAnalytics, setUserPostPageErrorAnalytics, } from '../../utils/add-manage-user-analytics';
import { UsersMultiselectActionButtons } from '../users-multiselect-action-buttons/users-multiselect-action-buttons';
import { MultiDeleteUserModal, } from '../modal/multi-delete-user-modal/multi-delete-user-modal';
import { MultiResendInvitesModal, } from '../modal/multi-resend-invite-modal/multi-resend-invite-modal';
import { addManageUsersApi } from '../../api/b2b/add-manage-user';
import ManageUserFormProvider from '../../contexts/manage-user-form-context';
export var AddManageUsersContent = function () {
    var _a = useAddManageUsers(), users = _a.users, alertMessage = _a.alertMessage, paginationInfo = _a.paginationInfo, currentSortByOptions = _a.currentSortByOptions, currentSearchByValues = _a.currentSearchByValues, showSearchResult = _a.showSearchResult, currentPageNumber = _a.currentPageNumber, formMode = _a.formMode, policy = _a.policy, setCurrentSortByOptions = _a.setCurrentSortByOptions, setCurrentSearchByValues = _a.setCurrentSearchByValues, setShowSearchResult = _a.setShowSearchResult, setCurrentPageNumber = _a.setCurrentPageNumber, setFormMode = _a.setFormMode, setAlertMessage = _a.setAlertMessage, getUsers = _a.getUsers, getPolicy = _a.getPolicy, hasProTradeCredit = _a.hasProTradeCredit, editableUser = _a.editableUser;
    var channel = useContext(ExperienceContext).channel;
    var _b = useState(false), loading = _b[0], setLoading = _b[1];
    var _c = useState(false), isSelectUsersModeOn = _c[0], setIsSelectUsersModeOn = _c[1];
    var _d = useState(true), isMultiInviteDisabled = _d[0], setIsMultiInviteDisabled = _d[1];
    var _e = useState(new Map()), checkedUserIdToUserData = _e[0], setCheckedUserIdToUserData = _e[1];
    var _f = useState(false), isPermissionsError = _f[0], setIsPermissionsError = _f[1];
    var _g = useState(null), currentSearchSortAction = _g[0], setCurrentSearchSortAction = _g[1];
    var _h = useModal(), openModal = _h.openModal, hideModal = _h.hideModal, setComponentProps = _h.setComponentProps;
    var enablePHAPermissions = !!useConfigService('ENABLE_PHA_PERMISSIONS');
    var isMobile = channel === 'mobile';
    var isDesktop = channel === 'desktop';
    var _j = useState(false), viewPurchasePolicyPermission = _j[0], setViewPurchasePolicyPermission = _j[1];
    var totalPages = Number(paginationInfo === null || paginationInfo === void 0 ? void 0 : paginationInfo.totalPages);
    var numberOfUsers = Number(paginationInfo === null || paginationInfo === void 0 ? void 0 : paginationInfo.totalNumberOfRecords);
    var selectedUsers = Array.from(checkedUserIdToUserData.values()).filter(function (user) { return user.accountOwner === 'N'; });
    var selectedPendingInviteUsers = Array.from(checkedUserIdToUserData.values()).filter(function (user) { return user.status === 'Pending'; });
    var isInviteExpirationEnabled = checkIsInviteExpirationEnabled();
    var showActionButtons = !!checkedUserIdToUserData.size;
    var someUsersSelected = !!((users === null || users === void 0 ? void 0 : users.length) &&
        checkedUserIdToUserData.size &&
        users.length !== checkedUserIdToUserData.size);
    var allUsersSelected = !!((users === null || users === void 0 ? void 0 : users.length) && users.length === checkedUserIdToUserData.size);
    useEffect(function () {
        setMyAccountPageAnalytics();
        triggerGetUsers(currentSortByOptions.sortBy, currentSearchByValues);
        getPolicy();
    }, []);
    useEffect(function () {
        if (policy) {
            var isViewPurchasePolicyActive = getViewPurchasePermission(policy);
            setViewPurchasePolicyPermission(isViewPurchasePolicyActive);
        }
    }, [policy]);
    var clearAlertMessage = function () { return setAlertMessage(null); };
    var handleSuccess = function (index, id, message) {
        setAlertMessage({
            text: message,
            alertStatus: TAlertStatus.SUCCESS,
            id: id,
            cardIndex: index,
            type: TAlertType.GENERAL,
        });
        if (message === USER_REMOVED_SUCCESS_MSG.message) {
            var newPage = getNewPageNumber(currentPageNumber, totalPages, users === null || users === void 0 ? void 0 : users.length);
            // ensure user stays on the same page or on the previous page (if last user deleted) to show delete confirmation
            onChangePage(newPage);
            return;
        }
        onChangePage(1);
    };
    var handleError = function (index, id, message) {
        setAlertMessage({
            text: message,
            alertStatus: TAlertStatus.ERROR,
            id: id,
            cardIndex: index,
            type: TAlertType.GENERAL,
        });
    };
    var triggerGetUsers = function (sortBy, filterOptions, pageNumber, ascendingOrder) {
        if (filterOptions === void 0) { filterOptions = defaultFilterConfig; }
        if (pageNumber === void 0) { pageNumber = 1; }
        if (ascendingOrder === void 0) { ascendingOrder = false; }
        var sortOptions = generateSortByOptions(sortBy, {
            page: pageNumber,
            ascendingOrder: ascendingOrder,
        });
        setLoading(true);
        return getUsers(sortOptions, filterOptions)
            .then(function () {
            setCurrentSortByOptions({
                sortBy: sortBy,
                ascendingOrder: ascendingOrder,
            });
            setCurrentSearchByValues(filterOptions);
            setCurrentPageNumber(pageNumber);
        })
            .catch(function () {
            setAlertMessage({
                text: ERR_GENERIC.message,
                alertStatus: TAlertStatus.ERROR,
                type: TAlertType.PAGE_LOAD_ERROR,
            });
        })
            .finally(function () {
            setLoading(false);
        });
    };
    var onChangePage = function (pageNumber) {
        setCheckedUserIdToUserData(new Map());
        triggerGetUsers(currentSortByOptions.sortBy, currentSearchByValues, pageNumber, currentSortByOptions.ascendingOrder);
        scrollToTop();
    };
    var _k = useState(1), countRender = _k[0], setCountRender = _k[1];
    useEffect(function () {
        var actionType = currentSearchSortAction;
        var numOfResults = null;
        // This counter is added because whenever we trigger any search or sort event, a spinner is rendered.
        // When we receive the results of the search or sort, a second render occurs.
        // This leads to the event being fired twice. During the first firing, we have outdated data
        // in currentSortByOptions and currentSearchByValues, so this event does not accurately reflect
        // the user's real intention. That's why we should register only the second event for accurate analytics.
        // It contains the updated values of currentSortByOptions and currentSearchByValues, plus the latest results.
        if (actionType !== null && !(countRender % 2)) {
            if (actionType === 'search') {
                numOfResults = numberOfUsers || 0;
            }
            setSearchSortResultsAnalytics(actionType, numOfResults, currentSortByOptions, currentSearchByValues);
        }
        setCountRender(function (count) { return count + 1; });
    }, [currentSortByOptions, currentSearchByValues]);
    var onSearchSubmit = function (_a) {
        var searchType = _a.searchType, searchValue = _a.searchValue;
        var searchByValues = {
            type: searchType,
            value: searchValue,
        };
        clearAlertMessage();
        setCurrentSearchSortAction('search');
        return triggerGetUsers(currentSortByOptions.sortBy, searchByValues, 1, currentSortByOptions.ascendingOrder).then(function () {
            if (searchByValues.type !== 'default') {
                setShowSearchResult(true);
            }
            else {
                setShowSearchResult(false);
            }
        });
    };
    var handleUserFormSuccess = function (expirationDate) {
        resetSearchAndSortBy();
        setFormMode(null);
        var userAddedMessage = expirationDate
            ? USER_ADDED_SUCCESS_MSG_WITH_EXPIRATION_DATE.message(expirationDate)
            : USER_ADDED_SUCCESS_MSG.message;
        setAlertMessage({
            text: formMode === USER_FORM_MODE.EDIT_USER
                ? USER_UPDATED_SUCCESS_MSG.message
                : userAddedMessage,
            alertStatus: TAlertStatus.SUCCESS,
            type: TAlertType.GENERAL,
        });
        scrollToTop();
    };
    var resetSearchAndSortBy = function () {
        setCurrentSearchByValues(defaultFilterConfig);
        setCurrentSortByOptions(defaultSortByOptions);
        triggerGetUsers(defaultSortByOptions.sortBy, defaultFilterConfig, 1, defaultSortByOptions.ascendingOrder);
    };
    var handleUserFormCancel = function () {
        resetSearchAndSortBy();
        setAlertMessage(null);
        setFormMode(null);
        scrollToTop();
    };
    var handleSortChange = function (sortBy, ascendingOrder) {
        clearAlertMessage();
        setCurrentSortByOptions({
            sortBy: sortBy,
            ascendingOrder: ascendingOrder,
        });
        setCurrentSearchSortAction('sort');
        triggerGetUsers(sortBy, currentSearchByValues, currentPageNumber, ascendingOrder);
    };
    var handleSelectAllChange = function (event) {
        if (checkedUserIdToUserData.size || !event.target.checked) {
            setCheckedUserIdToUserData(new Map());
            setIsMultiInviteDisabled(true);
            return;
        }
        if (event.target.checked && users) {
            var allCheckedUsers = new Map(users.map(function (user) {
                return [user.userId, user];
            }));
            setCheckedUserIdToUserData(allCheckedUsers);
            setIsMultiInviteDisabled(false);
            setMultiSelectOperationLinkAnalytics('select users');
        }
    };
    var handleSelectUserChange = function (event, user) {
        if (event.target.checked) {
            setCheckedUserIdToUserData(function (prevState) { return new Map(prevState.set(user.userId, user)); });
            setIsMultiInviteDisabled(Array.from(checkedUserIdToUserData.values()).every(function (item) { return item.status === 'Active'; }));
        }
        if (!event.target.checked) {
            setCheckedUserIdToUserData(function (prevState) {
                prevState.delete(user.userId);
                return new Map(prevState);
            });
            setIsMultiInviteDisabled(Array.from(checkedUserIdToUserData.values()).every(function (item) { return item.status === 'Active'; }));
        }
    };
    var multiRemoveUsers = function () {
        setComponentProps({ isLoading: true });
        addManageUsersApi
            .multiRemoveUsers(selectedUsers)
            .then(function () {
            setAlertMessage({
                text: USERS_REMOVED_SUCCESS_MSG.message,
                alertStatus: TAlertStatus.SUCCESS,
                type: TAlertType.GENERAL,
            });
            setBulkRemoveUsersSuccessAnalytics(selectedUsers.length);
        })
            .catch(function (error) {
            setAlertMessage({
                text: ERR_GENERIC.message,
                alertStatus: TAlertStatus.ERROR,
                type: TAlertType.GENERAL,
            });
            setUserPostPageErrorAnalytics('bulk add', 'inline', error.status || 'n/a', ERR_GENERIC.message);
        })
            .finally(function () {
            setComponentProps({ isLoading: false });
            hideModal();
            handleCancelSelectUsers();
            triggerGetUsers(currentSortByOptions.sortBy, currentSearchByValues);
        });
    };
    var handleMultiRemoveUsers = function () {
        openModal(MultiDeleteUserModal, {
            selectedUsers: selectedUsers,
            isLoading: false,
            onConfirmMultiDelete: multiRemoveUsers,
            hideModal: hideModal,
            handleClose: handleCancelSelectUsers,
            allUsersSelected: allUsersSelected,
        }, {
            onClose: function () {
                hideModal();
                handleCancelSelectUsers();
            },
        });
    };
    var multiResendInvites = function () {
        setComponentProps({ isLoading: true });
        addManageUsersApi
            .multiResendInvites(selectedPendingInviteUsers, isInviteExpirationEnabled)
            .then(function (_a) {
            var _b = _a.data, successCount = _b.successCount, userInviteExpirationDate = _b.userInviteExpirationDate;
            setAlertMessage({
                text: isInviteExpirationEnabled && userInviteExpirationDate
                    ? MULTI_RESEND_INVITE_SUCCESS_MSG_WITH_EXPIRATION.message(userInviteExpirationDate)
                    : MULTI_RESEND_INVITE_SUCCESS_MSG.message,
                alertStatus: TAlertStatus.SUCCESS,
                type: TAlertType.GENERAL,
            });
            setResendUserInvitesSuccessAnalytics(successCount);
        })
            .catch(function (error) {
            setAlertMessage({
                text: MULTI_RESEND_INVITE_ERROR_MSG.message,
                alertStatus: TAlertStatus.ERROR,
                type: TAlertType.GENERAL,
            });
            setUserPostPageErrorAnalytics('bulk add', 'inline', error.status || 'n/a', MULTI_RESEND_INVITE_ERROR_MSG.message);
        })
            .finally(function () {
            setComponentProps({ isLoading: false });
            hideModal();
            handleCancelSelectUsers();
        });
    };
    var handleMultiResendInvites = function () {
        openModal(MultiResendInvitesModal, {
            selectedPendingInviteUsers: selectedPendingInviteUsers,
            isLoading: false,
            onConfirmMultiResend: multiResendInvites,
            hideModal: hideModal,
            handleClose: handleCancelSelectUsers,
        }, {
            onClose: function () {
                hideModal();
                handleCancelSelectUsers();
            },
        });
    };
    var handleCancelSelectUsers = function () {
        setCheckedUserIdToUserData(new Map());
        setIsSelectUsersModeOn(false);
        setIsMultiInviteDisabled(true);
    };
    var mobileSuccessMsgUserRemoved = isMobile &&
        alertMessage &&
        alertMessage.text === USER_REMOVED_SUCCESS_MSG.message && (React.createElement("div", { className: isMobile ? 'sui-mt-4' : 'lg:sui-mb-8' },
        React.createElement(Alert, { "data-testid": "mobileSuccessMsgUserRemoved", status: alertMessage.alertStatus, onClose: function () { return setAlertMessage(null); } }, alertMessage.text)));
    var getUsersList = function () {
        var userList = (users === null || users === void 0 ? void 0 : users.map(function (user, index) {
            return isSelectUsersModeOn ? (React.createElement("label", { className: "sui-flex sui-items-center sui-h-full sui-ml-[-7px] ".concat(user.accountOwner === 'Y' ? 'sui-pl-9 sui-opacity-50' : ''), key: user.userId + '-' + user.addedDate },
                user.accountOwner !== 'Y' && (React.createElement(Checkbox, { value: checkedUserIdToUserData.has(user.userId).toString(), checked: checkedUserIdToUserData.has(user.userId), onChange: function (event) {
                        handleSelectUserChange(event, user);
                    } })),
                React.createElement(UserCard, { index: index, user: user, showMeatballsMenu: false }))) : (React.createElement("div", { key: user.userId + '-' + user.addedDate, className: "sui-flex ".concat(isMobile ? 'sui-flex-col' : '') },
                React.createElement(UserCard, { index: index, user: user, onActionSuccess: handleSuccess, onActionFailure: handleError })));
        })) || null;
        if (typeof (alertMessage === null || alertMessage === void 0 ? void 0 : alertMessage.cardIndex) === 'number' &&
            (alertMessage === null || alertMessage === void 0 ? void 0 : alertMessage.cardIndex) > 0 &&
            userList !== null) {
            userList.splice(alertMessage.cardIndex, 0, React.createElement(React.Fragment, { key: alertMessage.id }, mobileSuccessMsgUserRemoved));
        }
        return userList;
    };
    var handleLoading = function (status) {
        setLoading(status);
    };
    if (formMode) {
        switch (formMode) {
            case USER_FORM_MODE.ADD_USER:
            case USER_FORM_MODE.EDIT_USER:
                return enablePHAPermissions ? (React.createElement(ManageUserFormProvider, { isEditMode: formMode === USER_FORM_MODE.EDIT_USER, hasProTradeCredit: hasProTradeCredit, editableUser: editableUser },
                    React.createElement(ManageUserForm, { formMode: formMode, onCancel: handleUserFormCancel, onSuccess: handleUserFormSuccess, onError: function (reason) {
                            if (reason === 'permissionsFailure') {
                                setIsPermissionsError(true);
                            }
                        } }))) : (React.createElement(UserForm, { formMode: formMode, onSuccess: handleUserFormSuccess, onCancel: handleUserFormCancel }));
            case USER_FORM_MODE.BULK_ADD:
                return React.createElement(BulkAdd, null);
            default:
                return null;
        }
    }
    var handleViewPurchaseHistoryPermission = function (isActive) {
        var payload = getViewHistoryPayload(isActive);
        addManageUsersApi
            .saveViewPurchaseHistoryPolicy(payload)
            .then(function () { return getPolicy(); })
            .catch(function (error) {
            setAlertMessage({
                text: ERR_GENERIC.message,
                alertStatus: TAlertStatus.ERROR,
                type: TAlertType.TOGGLE,
            });
            setUserPostPageErrorAnalytics('bulk add', 'inline', error.code || 'n/a', MULTI_RESEND_INVITE_ERROR_MSG.message);
        });
    };
    var numberOfUsersMsg = !numberOfUsers
        ? 'No Results Found'
        : "".concat(numberOfUsers, " ").concat(numberOfUsers > 1 ? 'results' : 'result');
    return (React.createElement("div", null,
        loading && React.createElement(Spinner, { active: loading }),
        alertMessage && alertMessage.type === TAlertType.PAGE_LOAD_ERROR ? (React.createElement("div", { className: "sui-order-3 sui-col-span-full" },
            React.createElement(Alert, { "data-testid": "topAlertMsg", onClose: function () { return setAlertMessage(null); }, status: alertMessage.alertStatus }, alertMessage.text))) : (React.createElement(React.Fragment, null,
            React.createElement(ManageUsersHeader, { onLoading: handleLoading, onOpenForms: handleCancelSelectUsers }),
            React.createElement("div", { className: "sui-grid sui-grid-cols-1 sui-gap-y-4 sui-mb-8 md:sui-gap-y-6 md:sui-gap-x-8 2xl:sui-grid-cols-6 2xl:sui-gap-y-8 2xl:sui-gap-x-8 2xl:sui-mb-8" },
                React.createElement("div", { className: "sui-order-1 2xl:sui-col-span-3" },
                    React.createElement(UsersSearch, { values: currentSearchByValues, onSubmit: onSearchSubmit })),
                React.createElement("div", { className: "sui-order-2 2xl:sui-col-span-3" },
                    React.createElement(UserSortOrder, { currentSortByOption: currentSortByOptions.sortBy, onChange: handleSortChange }))),
            showSearchResult && (React.createElement("div", { className: "sui-mb-2" },
                React.createElement(Typography, { variant: "body-lg", weight: "bold" }, numberOfUsersMsg))),
            alertMessage &&
                alertMessage.type === TAlertType.GENERAL &&
                (isDesktop || (isMobile && !alertMessage.cardIndex)) && (React.createElement("div", { className: "sui-order-3 sui-col-span-full" },
                React.createElement(Alert, { "data-testid": "topAlertMsg", onClose: function () { return setAlertMessage(null); }, status: alertMessage.alertStatus, size: "large" }, alertMessage.text))),
            isPermissionsError && (React.createElement("div", { className: "sui-order-3 sui-col-span-full" },
                React.createElement(Alert, { "data-testid": "canNotSavePermissionsAlert", onClose: function () { return setIsPermissionsError(false); }, status: TAlertStatus.ERROR, size: "large" }, ERR_UNABLE_TO_SAVE_PAYMENT_PERMISSIONS.message))),
            React.createElement("div", { className: "sui-flex sui-flex-col-reverse 2xl:sui-flex-row sui-justify-between sui-items-baseline sui-mb-4" },
                !isSelectUsersModeOn && !!numberOfUsers && (React.createElement(Button, { className: "sui-block hover:sui-fill-brand sui-flex sui-gap-1", onClick: function () {
                        clearAlertMessage();
                        setIsSelectUsersModeOn(true);
                        setMultiSelectOperationLinkAnalytics('select users');
                    } },
                    React.createElement(Typography, { className: "sui-font-regular sui-text-base", decoration: "underline" }, "Select Users"))),
                isSelectUsersModeOn && (React.createElement("div", { className: "sui-flex sui-ml-0 sui-justify-between sui-w-full sm:sui-w-fit sm:sui-gap-6\n           sui-mb-4" },
                    React.createElement(SelectionControlLabel, { label: showActionButtons ? 'Unselect All' : 'Select All' },
                        React.createElement(Checkbox, { disabled: (users === null || users === void 0 ? void 0 : users.length) === 1 && users[0].accountOwner === 'Y', indeterminate: someUsersSelected, checked: allUsersSelected, onChange: handleSelectAllChange })),
                    React.createElement(UsersMultiselectActionButtons, { isMultiInviteDisabled: isMultiInviteDisabled, handleClose: handleCancelSelectUsers, isEnabled: showActionButtons, handleMultiRemove: handleMultiRemoveUsers, handleMultiResendInvites: handleMultiResendInvites }))),
                React.createElement("div", { className: "sui-flex sui-flex-col sui-mb-6 sui-gap-1 sui-w-full 2xl:sui-mb-0 2xl:sui-w-fit" },
                    React.createElement(UserPermissionsToggle, { onChangePermission: handleViewPurchaseHistoryPermission, isPermitted: viewPurchasePolicyPermission }),
                    alertMessage && alertMessage.type === TAlertType.TOGGLE && (React.createElement("div", { className: "sui-block 2xl:sui-hidden" },
                        React.createElement(Alert, { onClose: function () { return setAlertMessage(null); }, status: alertMessage.alertStatus }, alertMessage.text))))),
            alertMessage && alertMessage.type === TAlertType.TOGGLE && (React.createElement("div", { className: "sui-hidden 2xl:sui-block" },
                React.createElement(Alert, { onClose: function () { return setAlertMessage(null); }, status: alertMessage.alertStatus }, alertMessage.text))),
            React.createElement("div", { className: "sui-grid sui-grid-cols-1 sui-gap-y-4 sui-gap-x-4 md:sui-grid-cols-2 2xl:sui-gap-y-16 2xl:sui-gap-x-8 2xl:sui-grid-cols-3", "data-testid": "usersList" }, getUsersList()),
            totalPages > 1 && (React.createElement("div", { className: "sui-w-full sui-justify-center sui-mt-8 sui-flex sui-leading-[initial]" },
                React.createElement(Pagination, { currentPage: currentPageNumber, totalPages: totalPages, onPageChanged: function (pageNumber) {
                        clearAlertMessage();
                        onChangePage(pageNumber);
                    }, showArrows: totalPages > MAX_PAGES_TO_SHOW_ARROWS })))))));
};
